import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnNumberedList,
  BtnBulletList,
  BtnLink,
  BtnClearFormatting,
  createButton,
} from 'react-simple-wysiwyg'

const BtnAlignLeft = createButton('Align left', 'L', 'justifyLeft')
const BtnAlignCenter = createButton('Align center', 'C', 'justifyCenter')
const BtnAlignRight = createButton('Align right', 'R', 'justifyRight')

const toHtmlString = (value) => {
  if (typeof value === 'string') return value
  if (value === undefined || value === null) return ''
  return String(value)
}

export default function EditorField({ field, value, onChange }) {
  const { t } = useTranslation()
  const resolvedValue = useMemo(() => toHtmlString(value), [value])

  const handleChange = (event) => {
    const content = event?.target?.value ?? ''
    onChange?.(field.name, content)
  }

  return (
    <div className="col-span-full">
      <label htmlFor={field.name} className="block text-sm/6 font-medium text-gray-900">
        {field.label || field.name}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <div className="mt-2">
        <EditorProvider>
          <Editor
            id={field.name}
            value={resolvedValue}
            onChange={handleChange}
            placeholder={field.placeholder || t('singleCustomCollection.form.editorPlaceholder')}
          >
            <Toolbar>
              <BtnBold />
              <BtnItalic />
              <BtnUnderline />
              <BtnNumberedList />
              <BtnBulletList />
              <BtnAlignLeft />
              <BtnAlignCenter />
              <BtnAlignRight />
              <BtnLink />
              <BtnClearFormatting />
            </Toolbar>
          </Editor>
        </EditorProvider>
      </div>
    </div>
  )
}
